/* Contact form (custom-contact.hbs).
   =====================================================================
   Posts the Formspree form in place and reports the outcome in the form's
   live region. Messages come from the template as data attributes, so they
   are translated with {{t}} like every other string, and the server's
   messages are written as text, never as markup. */

export default function initContactForm({ root = document, fetchImpl } = {}) {
  const form = root.querySelector('form[data-contact-form]');
  if (!form) return null;

  const status = form.querySelector('[data-contact-status]');
  const request = fetchImpl || ((...args) => window.fetch(...args));
  const say = (text) => {
    if (status) status.textContent = text;
  };
  const failure = () => say(form.dataset.error || '');

  const onSubmit = (event) => {
    event.preventDefault();
    say('');
    request(form.action, {
      method: (form.getAttribute('method') || 'POST').toUpperCase(),
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (response.ok) {
          say(form.dataset.success || '');
          form.reset();
          return undefined;
        }
        return response.json().then((data) => {
          const messages = data && Array.isArray(data.errors) ? data.errors.map((e) => e && e.message).filter(Boolean) : [];
          if (messages.length) say(messages.join(', '));
          else failure();
        }, failure);
      })
      .catch(failure);
  };

  form.addEventListener('submit', onSubmit);
  return () => form.removeEventListener('submit', onSubmit);
}
